module.exports = __webpack_public_path__ + "img/ASO_fr23.efd501e1.png";